import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Margin, Padding } from 'styled-components-spacing';
import flexbox from 'styles/utils/flexbox';
import { useDispatch, useSelector } from 'react-redux';
import getAllowedPaymentOptions from 'state/checkoutPage/paymentOptions/operations/getAllowedPaymentOptions';
import { getLogo } from './getLogos';

function LogosPaymentComponent({ airlineWhitelabel }) {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAllowedPaymentOptions());
  }, [dispatch]);

  const { allowedPaymentOptions } = useSelector((state) => state.checkoutPagePaymentOptions);

  return (
    <LogosPaymentStyled airlineWhitelabel={airlineWhitelabel}>
      <Margin top={{ tiny: 2 }}>
        <Padding top={{ tiny: 2 }} bottom={{ tiny: 2 }}>
          <Logos>
            {allowedPaymentOptions && allowedPaymentOptions.map((paymentType) => getLogo(paymentType.type))}
          </Logos>
        </Padding>
      </Margin>
    </LogosPaymentStyled>
  );
}

export default LogosPaymentComponent;

// Styled components
const LogosPaymentStyled = styled.div`
  padding: 0 2rem;
  background-color: ${({ airlineWhitelabel }) =>
    airlineWhitelabel && airlineWhitelabel.isAirBaltic ? 'unset' : 'rgba(0, 0, 0, 0.25)'};
`;

const Logos = styled.div`
  ${flexbox({
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
  })}

  svg {
    max-width: 90px;
    height: 18px;
  }

  > * {
    max-height: 18px;
    margin: 1rem;
  }
`;
